import { useController } from 'react-hook-form';

import Counter, { ICounter } from '../../counter/TheCounter';
import { UseControllerProps } from './forms-types';

interface IControlledCounterProps {
  counterProps: ICounter;
  controllerProps: UseControllerProps;
}

const ControlledCounter: React.FC<IControlledCounterProps> = ({ counterProps, controllerProps }) => {
  const {
    field: { ref, ...controlerProps },
  } = useController({
    ...controllerProps,
  });
  return <Counter {...counterProps} {...controlerProps} inputRef={ref} />;
};

export default ControlledCounter;
